<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <div class="l-page__header c-page__header">
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        检测项目管理
      </h2>
      <div class="c-page__header-btns">
        <k-button
          type="primary"
          icon="kestrel-icon ki-search"
          btn-text="查询"
          @click="refreshSearch"
        />
        <k-button
          icon="kestrel-icon ki-repeat"
          btn-text="重置"
          @click="resetForm"
        />
        <k-button
          v-if="isProjectManager"
          type="success"
          icon="kestrel-icon ki-plus"
          btn-text="新增"
          :auth-type="false"
          @click="openNavTab({ name: 'jxxfJcProjectCreate' })"
        />
      </div>
    </div>
    <div class="l-page__item l-page--search__item">
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <el-form
          ref="filterParams"
          :model="filterParams"
          :inline="true"
          label-position="right"
          label-width="90px"
          label-suffix="："
          class="c-form c-condition__form"
        >
          <el-row class="c-form__row">
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                label="项目名称"
                prop="xmmc"
                class="c-form__item"
              >
                <el-input
                  v-model.trim="filterParams.xmmc"
                  clearable
                  maxlength="100"
                  placeholder="请输入项目名称"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                label="委托单位"
                prop="wtdw"
                class="c-form__item"
              >
                <el-input
                  v-model.trim="filterParams.wtdw"
                  clearable
                  maxlength="100"
                  placeholder="请输入委托单位"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                label="所属账号"
                prop="sszh"
                class="c-form__item"
              >
                <el-input
                  v-model.trim="filterParams.sszh"
                  clearable
                  maxlength="100"
                  placeholder="请输入所属账号"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                label="状态"
                prop="ztDm"
                class="c-form__item"
              >
                <el-select
                  v-model="filterParams.ztDm"
                  clearable
                  multiple
                  collapse-tags
                  placeholder="请选择状态"
                >
                  <el-option
                    v-for="item in statusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </hm-page-card>
    </div>
    <div class="l-page__body l-page--search__body">
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane label="查询结果">
          <k-table
            height="100%"
            :table-column="tableColumn"
            :data="page.rows"
            :pagination="page"
            @current-change="search"
            @size-change="handleSizeChange"
          >
            <template #xmmc="scope">
              <el-link
                type="primary"
                @click="openDetail(scope.row)"
              >
                {{ scope.row.xmmc }}
              </el-link>
            </template>
            <template #jcjl="scope">
              <span>{{ conclusionText(scope.row.jcjl) }}</span>
            </template>
            <el-table-column
              v-if="isProjectManager"
              label="操作"
              width="155"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <k-button
                  v-if="editable(scope.row)"
                  btn-text="编辑"
                  :auth-type="false"
                  type="primary"
                  plain
                  @click="openNavTab({ name: 'jxxfJcProjectEdit', params: { xmId: scope.row.uuid } })"
                />
                <k-button
                  v-if="scope.row.xmzt === 'WKS'"
                  btn-text="删除"
                  :auth-type="false"
                  type="danger"
                  plain
                  @click="deleteProject(scope.row)"
                />
                <k-button
                  v-if="canApplyModification(scope.row)"
                  btn-text="申请修改"
                  :auth-type="false"
                  type="warning"
                  plain
                  @click="modificationProjectId = scope.row.uuid"
                />
              </template>
            </el-table-column>
          </k-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <jc-xm-modification-dialog
      v-if="modificationProjectId"
      :xm-id="modificationProjectId"
      @close="modificationProjectId = null"
      @success="refreshSearch"
    />
  </div>
</template>

<script>
import { projectService } from './project.service.js';
import JcXmModificationDialog from './jcXmModificationDialog.vue';

export default {
  name: 'JxxfJcProjectIndex',
  components: { JcXmModificationDialog },
  data () {
    return {
      loading: false,
      isProjectManager: false,
      modificationProjectId: null,
      statusOptions: [
        { value: 'WKS', label: '未开始' }, { value: 'ZXZ', label: '执行中' },
        { value: 'DSC', label: '待生成报告' }, { value: 'DGZ', label: '待上传盖章签字报告' },
        { value: 'YWC', label: '已完成' }
      ],
      filterParams: { xmmc: null, wtdw: null, sszh: null, ztDm: [] },
      trueFilterParams: {},
      page: { rows: [], total: 0, pageSize: 15, pageNo: 0 },
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'xmmc', slotName: 'xmmc', label: '项目名称', align: 'left', minWidth: '200', type: 'text' },
        { key: 'wtdw', label: '委托单位', align: 'left', minWidth: '180', type: 'text' },
        { key: 'bgbh', label: '报告编号', align: 'left', minWidth: '160', type: 'text' },
        { key: 'jcjl', slotName: 'jcjl', label: '检测结论', align: 'left', minWidth: '100', type: 'text' },
        { key: 'sszhMc', label: '所属账号', align: 'left', width: '100', type: 'text' },
        { key: 'createTime', label: '创建时间', align: 'center', width: '150', type: 'dateTime' },
        { key: 'xmztMc', label: '当前状态', align: 'center', width: '120', type: 'text' }
      ]
    };
  },
  methods: {
    refreshSearch () {
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      this.search(1);
    },
    search (pageNo = 1) {
      this.loading = true;
      projectService.page(Object.assign({}, this.trueFilterParams, { pageNo, pageSize: this.page.pageSize }))
        .then(rsp => { this.page = Object.assign({}, this.page, rsp.data); })
        .finally(() => { this.loading = false; });
    },
    handleSizeChange (pageSize) { this.page.pageSize = pageSize; this.search(1); },
    resetForm () { this.$refs.filterParams.resetFields(); this.refreshSearch(); },
    conclusionText (value) {
      if (value === 'Y' || value === 'HG') return '合格';
      if (value === 'N' || value === 'BHG') return '不合格';
      return '/';
    },
    openDetail (row) { this.openNavTab({ name: 'jxxfJcProjectDetail', params: { xmId: row.uuid } }); },
    editable (row) { return ['WKS', 'ZXZ', 'DSC'].includes(row.xmzt); },
    canApplyModification (row) { return row.xmzt === 'DGZ'; },
    deleteProject (row) {
      this.$confirm(`确认删除项目：${row.xmmc}？`, '提示', { type: 'warning' })
        .then(() => projectService.delete(row.uuid))
        .then(() => { this.$message.success('删除成功'); this.search(1); });
    }
  },
  created () {
    this.isProjectManager = ((this.$HMStoreService.getUserinfo() || {}).roles || []).includes('JX-XMGLY');
  },
  mounted () {
    this.isProjectManager = ((this.$HMStoreService.getUserinfo() || {}).roles || []).includes('JX-XMGLY');
    this.refreshSearch();
  },
  activated () {
    // 列表页签启用了缓存，新增或编辑项目返回后需要重新查询最新数据。
    this.refreshSearch();
  }
};
</script>
